
import React, { useState, useEffect } from 'react';
import {
  Navbar,
  NavbarBrand,
  NavbarToggler,
  Collapse,
  Nav,
  NavItem,
  NavLink,
  UncontrolledDropdown,
  DropdownToggle,
  DropdownMenu,
  DropdownItem,
} from 'reactstrap';
import assets from '../assets/assets'; // Adjust the path to your logo image

const Header = () => {
  const [isOpen, setIsOpen] = useState(false);
  const [isMobile, setIsMobile] = useState(window.innerWidth <= 767);

  const toggle = () => setIsOpen(!isOpen);

  // Handle window resize for responsive design
  useEffect(() => {
    const handleResize = () => {
      setIsMobile(window.innerWidth <= 767);
    };

    window.addEventListener('resize', handleResize);
    return () => {
      window.removeEventListener('resize', handleResize);
    };
  }, []);

  // Base styles
  const styles = {
    header: {
      backgroundColor: '#e3f9f9',
      position: 'fixed',
      top: 0,
      left: 0,
      width: '100%',
      zIndex: 1000,
      boxShadow: '0 2px 5px rgba(0, 0, 0, 0.1)',
      fontFamily: 'Raleway, sans-serif',
    },
    navbar: {
      padding: isMobile ? '10px 15px' : '10px 20px',
      boxSizing: 'border-box',
    },
    brandContainer: {
      display: 'flex',
      alignItems: 'center',
      color: '#040695',
      textDecoration: 'none',
    },
    logo: {
      height: isMobile ? '80px' : '80px',
      width: 'auto',
      marginRight: '10px',
    },

    toggler: {
      border: 'none',
      color: '#040695',
    },
    nav: {
      marginLeft: 'auto',
      textAlign: isMobile ? 'center' : 'left',
      width: isMobile ? '100%' : 'auto',
    },
    navItem: {
      display: isMobile ? 'block' : 'inline-block',
      textAlign: 'center',
    },
    navLink: {
      color: '#040695',
      padding: isMobile ? '8px 10px' : '10px 15px',
      position: 'relative',
      transition: 'color 0.3s ease',
      display: 'block',
      textAlign: isMobile ? 'center' : 'left',
    },
    navLinkHover: {
      color: '#040695',
    },
    navLinkAfter: {
      content: '""',
      position: 'absolute',
      bottom: '5px',
      left: isMobile ? '50%' : '15px',
      transform: isMobile ? 'translateX(-50%)' : 'none',
      width: '0',
      height: '2px',
      backgroundColor: '#040695',
      transition: 'width 0.3s ease',
    },
    navLinkHoverAfter: {
      width: isMobile ? '50%' : 'calc(100% - 30px)',
    },
    dropdownToggle: {
      color: '#040695',
      padding: isMobile ? '8px 10px' : '10px 15px',
      display: 'flex',
      alignItems: 'center',
      justifyContent: isMobile ? 'center' : 'flex-start',
      width: '100%',
    },
    dropdownArrow: {
      marginLeft: '5px',

    },
    dropdownMenu: {
      backgroundColor: '#040695',
      border: 'none',
      borderRadius: '5px',
      width: '100%',
    },
    dropdownItem: {
      color: '#000',

      padding: '10px 20px',
      transition: 'background-color 0.3s ease',
      width: '100%',
      textAlign: isMobile ? 'center' : 'left',
    },
    dropdownItemHover: {
      backgroundColor: '#040695',
      color: 'white',
    },
    togglerIcon: {
      display: 'inline-block',
      width: '28px',
      height: '28px',
      backgroundRepeat: 'no-repeat',
      backgroundPosition: 'center',
      backgroundSize: '24px 24px',
      backgroundImage: "url(\"data:image/svg+xml;utf8,<svg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 30 30'><path stroke='%23040695' stroke-width='2.5' stroke-linecap='round' stroke-miterlimit='10' d='M4 7h22M4 15h22M4 23h22'/></svg>\")"
    }
  };
  return (
    <header style={styles.header}>
      <Navbar dark expand="md" style={styles.navbar}>
        <NavbarBrand href="/home" style={styles.brandContainer}>
          <img
            src={assets.logo}
            loading="lazy"
            alt="Sha tours Logo"
            style={styles.logo}
          />
        </NavbarBrand>
        <NavbarToggler
          onClick={toggle}
          style={styles.toggler}
          aria-label="Toggle navigation"
          aria-expanded={isOpen}
        >
          <span style={styles.togglerIcon} />
        </NavbarToggler>
        <Collapse isOpen={isOpen} navbar>
          <Nav navbar style={styles.nav}>
            <NavItem style={styles.navItem}>
              <NavLink
                href="/"
                style={styles.navLink}
                onMouseEnter={(e) => {
                  e.target.style.color = styles.navLinkHover.color;
                  e.target.style.setProperty(
                    '--after-width',
                    styles.navLinkHoverAfter.width
                  );
                }}
                onMouseLeave={(e) => {
                  e.target.style.color = styles.navLink.color;
                  e.target.style.setProperty('--after-width', '0');
                }}
                className="nav-link"
              >
                Welcome
                <style jsx>{`
                  .nav-link::after {
                    content: ${styles.navLinkAfter.content};
                    position: ${styles.navLinkAfter.position};
                    bottom: ${styles.navLinkAfter.bottom};
                    left: ${styles.navLinkAfter.left};
                    transform: ${styles.navLinkAfter.transform || 'none'};
                    width: var(--after-width, 0);
                    height: ${styles.navLinkAfter.height};
                    background-color: ${styles.navLinkAfter.backgroundColor};
                    transition: ${styles.navLinkAfter.transition};
                  }
                `}</style>
              </NavLink>
            </NavItem>
            <NavItem style={styles.navItem}>
              <NavLink
                href="/home"
                style={styles.navLink}
                onMouseEnter={(e) => {
                  e.target.style.color = styles.navLinkHover.color;
                  e.target.style.setProperty(
                    '--after-width',
                    styles.navLinkHoverAfter.width
                  );
                }}
                onMouseLeave={(e) => {
                  e.target.style.color = styles.navLink.color;
                  e.target.style.setProperty('--after-width', '0');
                }}
                className="nav-link"
              >
                Home
                <style jsx>{`
                  .nav-link::after {
                    content: ${styles.navLinkAfter.content};
                    position: ${styles.navLinkAfter.position};
                    bottom: ${styles.navLinkAfter.bottom};
                    left: ${styles.navLinkAfter.left};
                    transform: ${styles.navLinkAfter.transform || 'none'};
                    width: var(--after-width, 0);
                    height: ${styles.navLinkAfter.height};
                    background-color: ${styles.navLinkAfter.backgroundColor};
                    transition: ${styles.navLinkAfter.transition};
                  }
                `}</style>
              </NavLink>
            </NavItem>
            <NavItem style={styles.navItem}>
              <NavLink
                href="/about"
                style={styles.navLink}
                onMouseEnter={(e) => {
                  e.target.style.color = styles.navLinkHover.color;
                  e.target.style.setProperty(
                    '--after-width',
                    styles.navLinkHoverAfter.width
                  );
                }}
                onMouseLeave={(e) => {
                  e.target.style.color = styles.navLink.color;
                  e.target.style.setProperty('--after-width', '0');
                }}
                className="nav-link"
              >
                About
                <style jsx>{`
                  .nav-link::after {
                    content: ${styles.navLinkAfter.content};
                    position: ${styles.navLinkAfter.position};
                    bottom: ${styles.navLinkAfter.bottom};
                    left: ${styles.navLinkAfter.left};
                    transform: ${styles.navLinkAfter.transform || 'none'};
                    width: var(--after-width, 0);
                    height: ${styles.navLinkAfter.height};
                    background-color: ${styles.navLinkAfter.backgroundColor};
                    transition: ${styles.navLinkAfter.transition};
                  }
                `}</style>
              </NavLink>
            </NavItem>

            <NavItem style={styles.navItem}>
              <NavLink
                href="/services"
                style={styles.navLink}
                onMouseEnter={(e) => {
                  e.target.style.color = styles.navLinkHover.color;
                  e.target.style.setProperty(
                    '--after-width',
                    styles.navLinkHoverAfter.width
                  );
                }}
                onMouseLeave={(e) => {
                  e.target.style.color = styles.navLink.color;
                  e.target.style.setProperty('--after-width', '0');
                }}
                className="nav-link"
              >
                Services
                <style jsx>{`
                  .nav-link::after {
                    content: ${styles.navLinkAfter.content};
                    position: ${styles.navLinkAfter.position};
                    bottom: ${styles.navLinkAfter.bottom};
                    left: ${styles.navLinkAfter.left};
                    transform: ${styles.navLinkAfter.transform || 'none'};
                    width: var(--after-width, 0);
                    height: ${styles.navLinkAfter.height};
                    background-color: ${styles.navLinkAfter.backgroundColor};
                    transition: ${styles.navLinkAfter.transition};
                  }
                `}</style>
              </NavLink>
            </NavItem>
            <NavItem style={styles.navItem}>
              <NavLink
                href="/faq"
                style={styles.navLink}
                onMouseEnter={(e) => {
                  e.target.style.color = styles.navLinkHover.color;
                  e.target.style.setProperty(
                    '--after-width',
                    styles.navLinkHoverAfter.width
                  );
                }}
                onMouseLeave={(e) => {
                  e.target.style.color = styles.navLink.color;
                  e.target.style.setProperty('--after-width', '0');
                }}
                className="nav-link"
              >
                FAQ
                <style jsx>{`
                  .nav-link::after {
                    content: ${styles.navLinkAfter.content};
                    position: ${styles.navLinkAfter.position};
                    bottom: ${styles.navLinkAfter.bottom};
                    left: ${styles.navLinkAfter.left};
                    transform: ${styles.navLinkAfter.transform || 'none'};
                    width: var(--after-width, 0);
                    height: ${styles.navLinkAfter.height};
                    background-color: ${styles.navLinkAfter.backgroundColor};
                    transition: ${styles.navLinkAfter.transition};
                  }
                `}</style>
              </NavLink>
            </NavItem>
            <NavItem style={styles.navItem}>
              <NavLink
                href="/contact"
                style={styles.navLink}
                onMouseEnter={(e) => {
                  e.target.style.color = styles.navLinkHover.color;
                  e.target.style.setProperty(
                    '--after-width',
                    styles.navLinkHoverAfter.width
                  );
                }}
                onMouseLeave={(e) => {
                  e.target.style.color = styles.navLink.color;
                  e.target.style.setProperty('--after-width', '0');
                }}
                className="nav-link"
              >
                Contact
                <style jsx>{`
                  .nav-link::after {
                    content: ${styles.navLinkAfter.content};
                    position: ${styles.navLinkAfter.position};
                    bottom: ${styles.navLinkAfter.bottom};
                    left: ${styles.navLinkAfter.left};
                    transform: ${styles.navLinkAfter.transform || 'none'};
                    width: var(--after-width, 0);
                    height: ${styles.navLinkAfter.height};
                    background-color: ${styles.navLinkAfter.backgroundColor};
                    transition: ${styles.navLinkAfter.transition};
                  }
                `}</style>
              </NavLink>
            </NavItem>

          </Nav>
        </Collapse>
      </Navbar>
    </header>
  );
};

export default Header;
